import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';
import {SidePanel} from 'front-onceforall-core';
import {interventionRole} from '../../../../../utils/constant';

function SelectInterventionPanelView(props) {
  const history = useHistory();

  if (!props.isOpen) {
    return null;
  }

  let triggerClosePanel = () => {};

  function handleSelection(intervention) {
    history.push(`/project/${props.project.projectId}/intervention/${intervention.id}`);
  }

  function getInvitingOrganisation(intervention) {
    const shouldShow = intervention.invitingOrganisation &&
      (intervention.role === interventionRole.SUB_CONTRACTOR || intervention.role === interventionRole.SERVICE_PROVIDER);

    return shouldShow ? (
      <Translate
        value="project.selectIntervention.invitedBy"
        invitingOrganisationName={intervention.invitingOrganisation.fullName}
      />
    ) : null;
  }

  return (
    <SidePanel
      onClose={props.onClose}
      setCloseTrigger={closeFunction => {
        triggerClosePanel = closeFunction;
      }}
    >
      <h2><Translate value="project.selectIntervention.title"/></h2>
      <p>
        <Translate
          value="project.selectIntervention.message"
          projectName={props.project.name}
        />
      </p>
      {props.project.interventions.map((intervention, index) => <div
        className="box my-2 clickable"
        data-id={`intervention-${index}`}
        key={`intervention-${index}`}
        onClick={() => handleSelection(intervention)}
      >
        <div className="clickable">
          <Translate value={`intervention.role.${intervention.role}`}/>
        </div>
        <span className="font-size-s">
          {getInvitingOrganisation(intervention)}
        </span>
      </div>)}
      <div className="mt-5">
        <button
          type="button"
          className="large secondary"
          onClick={() => triggerClosePanel()}
        >
          <Translate value="action.cancel"/>
        </button>
      </div>
    </SidePanel>
  );
}

SelectInterventionPanelView.propTypes = {
  project: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SelectInterventionPanelView;
